<template>
  <a-layout-sider
    v-model="getCollapsed"
    :trigger="null"
    collapsible
    class="admin-left"
  >
    <a-menu
      theme="light"
      mode="inline"
      :default-selected-keys="defaultSelectedKeys"
      :default-open-keys="defaultOpenKeys"
      @openChange="onOpenChange"
    >
      <template v-for="item in menuData">
        <template v-if="!item.hidden">
          <template v-if="!item.hideChildrenInMenu">
            <a-menu-item v-if="!item.children && !item.hidden" :key="item.name">
              <a-icon :type="item.meta.icon" />
              <span>{{ item.meta.title }}</span>
            </a-menu-item>
            <sub-menu v-else :key="item.path" :menuInfo="item" />
          </template>
          <template v-else>
            <a-menu-item :key="item.name">
              <router-link :to="item.path">
                <a-icon :type="item.meta.icon" />
                <span>{{ item.meta.title }}</span>
              </router-link>
            </a-menu-item>
          </template>
        </template>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
import { mapGetters } from "vuex";
import { Menu } from "ant-design-vue";
import { mapState } from "vuex";
/**
 * hideChildrenInMenu的作用
 * children下面有内容，但是又不想显示在菜单上，还要父菜单是一个链接可以点击，而不是一个展开层
 */
const SubMenu = {
  template: `
      <a-sub-menu :key="menuInfo.name" v-bind="$props" v-on="$listeners">
        <span slot="title">
          <a-icon v-if="menuInfo.meta.icon" :type="menuInfo.meta.icon" /><span>{{ menuInfo.meta.title }}</span>
        </span>
        <template v-for="item in menuInfo.children">
          <template v-if="!item.hidden">
            <template v-if="!item.hideChildrenInMenu">
              <a-menu-item v-if="!item.children && !item.hidden" :key="item.name">
                <router-link :to="item.path">
                  <span>{{ item.meta.title }}</span>
                </router-link>
              </a-menu-item>
              <sub-menu v-else :key="item.name" :menu-info="item" />
            </template>
            <template v-if="item.hideChildrenInMenu">
              <a-menu-item >
                <router-link :to="item.path">
                  <span>{{ item.meta.title }}</span>
                </router-link>
              </a-menu-item>
            </template>
          </template>
        </template>
      </a-sub-menu>
    `,
  name: "SubMenu",
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
};
export default {
  components: {
    "sub-menu": SubMenu,
  },
  computed: {
    ...mapGetters("setting", ["getCollapsed"]),
    ...mapState("setting", ["isMobile", "isMenu", "menu"]),
  },
  props: ["collapsed"],
  data() {
    return {
      rootSubmenuKeys: [],
      defaultOpenKeys: [],
      defaultSelectedKeys: [],
      menuData: [],
      vArr: [], //用来接收相关联父级name的集合
    };
  },
  created() {
    this.start();
  },
  methods: {
    start() {
      // this.menuData = this.$router.options.routes;
      this.menuData = this.menu;
      // console.log(this.menuData);
      this.defaultSelectedKeys = [this.$route.name];
      this.getDefaultOpenKeys(this.$route.name);
    },
    shellArr(obj, id) {
      if (obj.length) {
        obj.forEach(item => {
          if (item.children && item.children.length) {
            if (item.children.some(row => row.name === id)) {
              //这里利用some筛选子级有没有符合条件的，有就重新递归，没有就继续递归
              this.vArr.unshift(item.name);
              //重新递归
              this.shellArr(this.menuData, item.name);
            } else {
              //继续递归
              this.shellArr(item.children, id);
            }
          } else {
            return;
          }
        });
      }
    },
    // 用当前路由递归取到刷新时默认打开的层级
    getDefaultOpenKeys(nowRoute) {
      this.shellArr(this.menuData, nowRoute);
      this.defaultOpenKeys = this.vArr; //相关父级集合
    },
    onOpenChange(openKeys) {
      console.log(openKeys);
      // const latestOpenKey = openKeys.find(
      //   key => this.openKeys.indexOf(key) === -1
      // );
      // if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      //   this.openKeys = openKeys;
      // } else {
      //   this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      // }
    },
  },
  watch: {
    isMenu: function() {
      // console.log(this.isMenu)
      // console.log(this.menu)
      // 路由对象改变时
      this.start();
    },
  },
};
</script>
